<template>
  <div>
    <v-container class="py-12 py-md-16">
      <div class="text-center mb-12">
        <v-chip variant="tonal" color="primary" class="mb-4">Comparisons</v-chip>
        <h1 class="compare-hub-h1 mb-4">How Song7 compares</h1>
        <p class="text-h6 text-medium-emphasis mx-auto" style="max-width: 720px">
          Honest comparisons between Song7 and the other tools worship teams consider. We name where the competitor wins
          and where Song7 wins, and we update each page as products change.
        </p>
      </div>

      <v-row>
        <v-col v-for="card in cards" :key="card.title" cols="12" md="6" lg="4">
          <v-card
            :to="card.to"
            :disabled="card.comingSoon"
            class="pa-6 h-100 compare-card"
            elevation="0"
            border
            rounded="xl"
          >
            <v-chip v-if="card.comingSoon" size="x-small" color="grey" class="mb-3"> Coming soon </v-chip>
            <h2 class="text-h6 font-weight-bold mb-2">{{ card.title }}</h2>
            <p class="text-body-2 text-medium-emphasis mb-0">{{ card.summary }}</p>
          </v-card>
        </v-col>
      </v-row>

      <div class="text-center mt-12">
        <p class="text-body-2 text-medium-emphasis">
          Don't see your current tool listed?
          <NuxtLink to="/contact">Let us know</NuxtLink> what you'd want compared next.
        </p>
      </div>
    </v-container>
  </div>
</template>

<script setup>
import { useSeo } from '~/composables/useSeo'

definePageMeta({
  layout: 'website',
})

// Hub cards come from the shared list so the hub and every page's related
// block stay in sync. `visibleComparePages` drops any hidden (work-in-progress)
// page. See app/utils/comparePages.ts.
const cards = visibleComparePages

// The description names each listed comparison by hand — update it when a page in
// app/utils/comparePages.ts is added, hidden or unhidden.
useSeo({
  keywords: [
    'worship app comparison',
    'worship chord chart app',
    'planning center music stand alternative',
    'onsong alternative',
    'worship binder alternative',
    'songselect setlist app',
    'worship setlist app',
  ],
  schema: 'WebApplication',
})
</script>

<style scoped>
.compare-hub-h1 {
  font-size: clamp(34px, 5vw, 56px);
  font-weight: 800;
  letter-spacing: -0.025em;
  line-height: 1.1;
}

.compare-card {
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease;
}

.compare-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.06);
}
</style>
